import React from 'react';

const ContactDisclaimer = () => {
  return (
    <div className="mt-8 py-4 px-1">
      <p className="text-sm text-[#A0A0A0] leading-relaxed">
        <span className="font-medium">Disclaimer:</span> Eluno Consulting provides strategic and advisory consulting services. Information shared during consultations is for guidance purposes only and does not constitute legal or operational advice. Clients retain full responsibility for implementation decisions and results.
      </p>
    </div>
  );
};

export default ContactDisclaimer;